import { render, staticRenderFns } from "./LogoTempSVG.vue?vue&type=template&id=079a4199&"
import script from "./LogoTempSVG.vue?vue&type=script&lang=js&"
export * from "./LogoTempSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports